import { getApiErrorMessage } from "../utils/apierror";
import { BaseService } from "./BaseService";

export class IqLookupService extends BaseService {
  async getMeasurementDates(profileId) {
    const mergedArr = [];
    const result = await super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETMEASUREMENTDATES + "?profileID=" + profileId
    );
    if (!result || !result.startDates || !result.endDates) {
      throw new Error(getApiErrorMessage(result, "Unable to download Measurement Dates. Please try again."));
    }
    for (let i = 0; i < result.startDates.length; i++) {
      mergedArr.push({ startDate: result.startDates[i].date, endDate: result.endDates[i].date });
    }
    mergedArr.sort((a, b): any => {
      return new Date(a.startDate) > new Date(b.startDate) ? 1 : new Date(a.startDate) < new Date(b.startDate) ? -1 : 0;
    });
    return mergedArr.map((item) => {
      item.startDate = item.startDate ? new Date(item.startDate).toLocaleDateString("en-US") : "";
      item.endDate = item.endDate ? new Date(item.endDate).toLocaleDateString("en-US") : "";
      return item;
    });
  }

  getCurrencies(profileId) {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETCURRENCIES + "?profileID=" + profileId);
  }

  async getFilterFields(profileId) {
    const result = await super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETFILTERFIELDS + "?profileID=" + profileId
    );
    if (!Array.isArray(result)) {
      throw new Error(getApiErrorMessage(result, "Unable to download Filter Fields. Please try again."));
    }
    return result.map((item) => {
      item.vehicleType = item.vehicleType ? item.vehicleType : "";
      return item;
    });
  }

  async getFilterValues(profileId) {
    const result = await super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETFILTERVALUES + "?profileID=" + profileId
    );
    if (!Array.isArray(result)) {
      throw new Error(getApiErrorMessage(result, "Unable to download Filter Values. Please try again."));
    }
    return result.map((item) => {
      item.vehicleType = item.vehicleType ? item.vehicleType : "";
      return item;
    });
  }
}
